import { useState } from "react";
import { BRAND, BRAND_LIGHT, LINE, MUTED, text, SURFACE, INK, NEUTRAL_BG, TEXT, WHITE } from "./constants";
import { Icon, ConfirmBar } from "./shared";
import { useIsMobile } from "./lib/responsive";

// Las referencias aprobadas desde el formulario público antes del 10/10 se
// guardaron solo con name/role/questions/responses: se reconstruyen aquí.
export const refView = (ref_) => ({
  title: ref_.title || [ref_.name || ref_.email, ref_.role].filter(Boolean).join(" — "),
  subtitle: ref_.subtitle != null ? ref_.subtitle : (ref_.title ? "" : ref_.email || ""),
  items: Array.isArray(ref_.items) ? ref_.items
    : (ref_.questions || []).map(q => [q.text, (ref_.responses || {})[q.id]]).filter(([, v]) => v && String(v).trim()),
});

const RefAccordion = ({ ref_, lang, onDelete }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const [confirmDel, setConfirmDel] = useState(false);
  const labelMap = {
    en: {
      "Main strengths": "Main strengths",
      "Areas for improvement": "Areas for improvement",
      "Leadership style": "Leadership style",
      "Culture fit": "Culture fit",
      "Challenging situation": "Challenging situation",
      "Additional comments": "Additional comments",
    },
    es: {
      "Main strengths": "Principales fortalezas",
      "Areas for improvement": "Áreas de mejora",
      "Leadership style": "Estilo de liderazgo",
      "Culture fit": "Encaje cultural",
      "Challenging situation": "Situación de reto",
      "Additional comments": "Comentarios adicionales",
    },
  };
  const labels = labelMap[lang] || labelMap.en;
  const { title, subtitle, items } = refView(ref_);
  return (
    <div style={{ border: `1.5px solid ${open ? BRAND + "44" : LINE}`, borderRadius: 14, overflow: "hidden", transition: "border-color 0.2s" }}>
      <button onClick={() => setOpen(o => !o)} style={{ width: "100%", background: open ? BRAND_LIGHT : SURFACE, border: "none", padding: isMobile ? "12px 14px" : "16px 18px", cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, fontFamily: "inherit" }}>
        <div>
          <div style={{ fontWeight: isMobile ? 700 : 800, fontSize: isMobile ? 13 : 15, color: INK, marginBottom: 3 }}>{title}</div>
          <div style={{ fontSize: 12, color: MUTED }}>{subtitle}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          {onDelete && (
            <div onClick={e => { e.stopPropagation(); setConfirmDel(v => !v); setOpen(false); }} style={{ width: 26, height: 26, borderRadius: "50%", background: NEUTRAL_BG, border: confirmDel ? `1.5px solid ${LINE}` : "1.5px solid transparent", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.15s" }}
              title={lang === "es" ? "Eliminar referencia" : "Delete reference"}>
              <Icon name="trash" size={11} color={confirmDel ? TEXT : MUTED} />
            </div>
          )}
          <div style={{ width: 24, height: 24, borderRadius: "50%", background: open ? BRAND : LINE, display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.2s" }}>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d={open ? "M2 7L5 4L8 7" : "M2 4L5 7L8 4"} stroke={open ? WHITE : MUTED} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </button>
      {confirmDel && (
        <ConfirmBar
          message={lang === "es" ? "¿Eliminar esta referencia?" : "Delete this reference?"}
          actionLabel={lang === "es" ? "Eliminar" : "Delete"}
          cancelLabel={lang === "es" ? "Cancelar" : "Cancel"}
          onConfirm={() => { onDelete(); setConfirmDel(false); }}
          onCancel={() => setConfirmDel(false)}
          style={{ borderRadius: 0, border: "none", borderTop: "1px solid " + LINE }} />
      )}
      {open && (
        <div style={{ padding: "18px 18px 20px", background: WHITE, borderTop: `1px solid ${NEUTRAL_BG}` }}>
          {items.map(([label, value], i) => (
            <div key={i} style={{ marginBottom: i < items.length - 1 ? 16 : 0 }}>
              <div style={{ ...text.label, marginBottom: 4 }}>{labels[label] || label}</div>
              <div style={{ fontSize: 13, color: TEXT, lineHeight: 1.6 }}>{value}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default RefAccordion;
